import NotFound from "./pages/not-found";
import UpgradeZba from "pages/upgrade-zba";
import Success from "pages/success";
import LandingPage from "pages/landing-page";

const routes = [
  { key: "notfound", path: "/*", exact: true, element: <NotFound /> },
  { key: "notfound", path: "/nf", exact: true, element: <NotFound /> },
  { key: "lp", path: "/lp", exact: true, element: <LandingPage /> },
  {
    key: "upgradezba",
    path: "/upgrade-zba",
    exact: true,
    element: <UpgradeZba />,
  },
  {
    key: "success",
    path: "/success",
    exact: true,
    element: <Success />,
  },
];
export default routes;
